import CityExplanationIndex from '@/features/explanation/pages/city'
import ContinentExplanationIndex from '@/features/explanation/pages/continent'
import CountryExplanationIndex from '@/features/explanation/pages/country'
import ScenicExplanationIndex from '@/features/explanation/pages/scenic'
import { regionInfoQueryOptions } from '@/features/explanation/query-options'
import { SearchSchema } from '@/features/explanation/schemas/search'
import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'


export const Route = createFileRoute(
    '/_authenticated/explanations/$regionType/$id',
)({
    validateSearch: zodValidator(SearchSchema),
    loader: async ({ context, params }) => {
        const { queryClient } = context
        await queryClient.ensureQueryData(
            regionInfoQueryOptions({
                key: `region-${params.regionType}`, search: {
                    page: 1,
                    size: 9999,
                    regionId: Number(params.id),
                    regionType: params.regionType,
                },
            })
        )
    },
    component: IndexComponent,
})

function IndexComponent() {

    const params = Route.useParams()
    const regionType = params.regionType

    switch (regionType) {
        case 'scenic-areas':
            return <ScenicExplanationIndex />
        case 'city':
            return <CityExplanationIndex />
        case 'country':
            return <CountryExplanationIndex />
        case 'continent':
            return <ContinentExplanationIndex />
        default:
            return (
                <div className='flex flex-col items-center justify-center h-screen'>
                    <h1 className='text-2xl font-bold'>[🙅] 区域类型 {regionType} 未知</h1>
                </div>
            )
    }
}
